// axiosClient.js
import axios from 'axios';
import router from '../router';
import env from '../env.js';
import store from '../store/store';

let isLoggedOut = false;

const axiosClient = axios.create({
  baseURL: `${env.domain}/api/candidate/`,
  headers: { 'X-Requested-With': 'XMLHttpRequest' }
});

axiosClient.interceptors.request.use((config) => {
  const token = getToken();
  const isLoginRequest = config.url.endsWith('/login');

  if (!token && !isLoginRequest) {
    return Promise.reject({ response: { status: 401, data: { success: false, message: 'Session expired' } } });
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.headers['Accept'] = 'application/json';
  config.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

  return config;
}, (error) => {
  return Promise.reject(error);
});

// Response Interceptor
axiosClient.interceptors.response.use((response) => {
  showAlert(response.data);
  return response;

}, (error) => {

    const res = error.response;

    if (res) {

        showAlert(res.data);

        if (res.status === 401) { handleLogout(); }

        return Promise.resolve(res);

    } else {
        store.dispatch("changeLoaderValue", false)
        store.dispatch('alertError', 'Network error or server is unreachable');
        return Promise.reject(error);
    }
});

function getToken() {
  const localUser = localStorage.getItem(env.localUserKey);
  if (!localUser) return null;

  try {
    const { token, tokenExpirationDate } = JSON.parse(unescape(atob(localUser)));
    return new Date(tokenExpirationDate) < new Date() ? null : token;
  } catch (e) {
    console.error('Failed to parse auth token:', e);
    return null;
  }
}

function showAlert(data) {

    if (isLoggedOut || !data?.message) return;

    const messages = Array.isArray(data.message) ? data.message : [data.message];
    messages.forEach(msg => {
        const type = data.success ? 'alertSuccess' : 'alertError';
        store.dispatch(type, msg);
    });
}

function handleLogout() {
  if (isLoggedOut) return;
  isLoggedOut = true;

  localStorage.removeItem(env.localUserKey);

  router.push({
    path: '/login',
    query: {
      intended: btoa(unescape(encodeURIComponent(location.href)))
    }
  });
}

export default axiosClient;
